<div class="container-fluid" style="background-color: #1d2229">
    <div class="row">
        <div class="col-sm-2">
            <div class="content">
                <div class="container-lg text-center" style="background-color: #1d2229">
                    <div class="row">
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['dock', 12]"
                                [ngStyle]="{ color: statusDocks(12) }">
                                Doca 1
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['dock', 1]"
                                [ngStyle]="{ color: statusDocks(1) }">
                                Doca 2
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['dock', 5]"
                                [ngStyle]="{ color: statusDocks(5) }">
                                Doca 3
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['dock', 6]"
                                [ngStyle]="{ color: statusDocks(6) }">
                                Doca 4
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['dock', 11]"
                                [ngStyle]="{ color: statusDocks(11) }">
                                Doca 5
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" (click)="openPlanning()">
                                Programação
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-10">
            <router-outlet></router-outlet>
        </div>

    </div>
</div>

<app-planning-table *ngIf="planningIsVisible"></app-planning-table>